import axios from 'axios';
import type {
  LatestPrice,
  CandlesData,
  IndicatorsData,
  VolumeData,
  VolatilityData,
  ComparisonData,
  ShortSqueezeData,
  TimeRange,
  IndicatorType,
  IndicatorPeriod,
} from '../types';

// Configure your API base URL
// For development: use your wrangler dev URL
// For production: use your deployed API Worker URL
const API_BASE_URL = import.meta.env.VITE_API_URL || 'http://localhost:8787';

const api = axios.create({
  baseURL: API_BASE_URL,
  timeout: 30000, // Increase to 30 seconds for all endpoints
});

export const getLatestPrice = async (): Promise<LatestPrice> => {
  const response = await api.get<LatestPrice>('/api/latest');
  return response.data;
};

export const getCandles = async (range: TimeRange): Promise<CandlesData> => {
  const response = await api.get<CandlesData>('/api/candles', {
    params: { range },
  });
  return response.data;
};

export const getIndicators = async (
  type: IndicatorType,
  period: IndicatorPeriod,
  range: TimeRange
): Promise<IndicatorsData> => {
  const response = await api.get<IndicatorsData>('/api/indicators', {
    params: { type, period, range },
  });
  return response.data;
};

export const getVolume = async (range: TimeRange): Promise<VolumeData> => {
  const response = await api.get<VolumeData>('/api/volume', {
    params: { range },
  });
  return response.data;
};

export const getVolatility = async (range: TimeRange): Promise<VolatilityData> => {
  const response = await api.get<VolatilityData>('/api/volatility', {
    params: { range },
  });
  return response.data;
};

export const getComparison = async (periods: string[]): Promise<ComparisonData> => {
  const response = await api.get<ComparisonData>('/api/comparison', {
    params: { periods: periods.join(',') },
    timeout: 15000, // Increase timeout to 15 seconds for comparison endpoint
  });
  return response.data;
};

export const getShortSqueeze = async (): Promise<ShortSqueezeData> => {
  const response = await api.get<ShortSqueezeData>('/api/short-squeeze');
  return response.data;
};
